import React from 'react';
import { EmptyText, Link, Row, Stack, Text, Title } from 'library/ui';

import { Notification } from './Notification';

import type { NotificationType } from 'models';
import type { DashboardSummary } from '../types';
import { useUserContext } from 'UserContext';
import { BasicCard } from './BasicCard';

const VPK_NOTIFICATION: NotificationType = {
    id: -1,
    message:
        'After utilizing a specific substitute for four weeks in a VPK program (or 60 program hours), please add them to your VPK program portal. You can track hours worked by Tandem substitutes via My Staff.',
    added_at: 'VPK Providers',
    image: null,
    clicked: false,
    viewed: false,
    marked_as_read: false,
    hide_mark_as_read: true,
    actions: [
        {
            name: 'View My Staff',
            action: 'navigate',
            action_type: 'web',
            path: '/providers',
            extra_data: null,
        },
    ],
};

export function Notifications({ data }: { data: DashboardSummary }) {
    const { user } = useUserContext();
    const isManateeCounty = user?.address?.some(
        (a) => a.county?.toLowerCase() === 'manatee' && a.state?.toLowerCase() === 'florida',
    );
    const showVPKNotification = isManateeCounty;
    const extraNotifications = showVPKNotification ? 1 : 0;
    const unreads: NotificationType[] | undefined = data?.notifications?.unread;
    const unreadCount: number = (data?.notifications?.unread_count || 0) + extraNotifications;
    const max = 5;
    return (
        <BasicCard loading={false}>
            <Stack gap="md" fullWidth fullHeight justify="between">
                <Stack gap="sm" fullWidth>
                    <Row justify="between">
                        <Title size="h2">Latest Notifications</Title>
                        {!!unreadCount && (
                            <Text size="xs" tone="secondary">
                                {max}/{unreadCount}
                            </Text>
                        )}
                    </Row>
                    {showVPKNotification && <Notification notification={VPK_NOTIFICATION} />}
                    {!unreadCount ? (
                        <EmptyText padding="sm">You&apos;re all caught up!</EmptyText>
                    ) : (
                        unreads.map(
                            (notification: NotificationType, index: number) =>
                                index < max && <Notification key={notification.id} notification={notification} />,
                        )
                    )}
                </Stack>
                {!!unreadCount && (
                    <Row justify="end" fullWidth>
                        <Link to="/notifications" size="sm" underline={false}>
                            View All
                        </Link>
                    </Row>
                )}
            </Stack>
        </BasicCard>
    );
}
